import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { CA, PAIR_ADDRESS } from "../constants";

export const LiveChart = () => {
  const [pair, setPair] = useState(PAIR_ADDRESS);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const r = await fetch(`https://api.dexscreener.com/latest/dex/tokens/${CA}`);
        const pairs = ((await r.json()).pairs || []).filter((p) => p.chainId === "solana");
        pairs.sort((a, b) => ((b.liquidity || {}).usd || 0) - ((a.liquidity || {}).usd || 0));
        if (alive && pairs[0]?.pairAddress) setPair(pairs[0].pairAddress);
      } catch {
        /* keep fallback */
      }
    };
    load();
    return () => {
      alive = false;
    };
  }, []);

  return (
    <section id="chart" className="relative z-10 max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-20 sm:py-28">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <p className="font-bebas tracking-[0.35em] text-[#9945FF] text-lg">WATCH IT LIVE</p>
        <h2 className="font-marker text-4xl sm:text-5xl lg:text-6xl mt-2">
          THE <span className="gradient-sol">CHART</span>
        </h2>
        <p className="text-zinc-400 mt-3 max-w-xl">
          Real candles. Real volume. Curb doesn't refresh this page — he already knows where it's going.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.15 }}
        className="neon-card mt-10 overflow-hidden p-1.5 sm:p-2"
      >
        <iframe
          data-testid="live-chart-iframe"
          title="$CURB live chart"
          src={`https://www.geckoterminal.com/solana/pools/${pair}?embed=1&info=0&swaps=0`}
          className="w-full h-[420px] sm:h-[560px] rounded-lg border-0"
          allow="clipboard-write"
          allowFullScreen
        />
      </motion.div>
    </section>
  );
};
